'use strict';
var wellKnownSymbol = require('../internals/well-known-symbol');

exports.f = wellKnownSymbol;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/internals/well-known-symbol-wrapped.js
// module id = 110
// module chunks = 13